import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from './ProtectedRoute';

const Dashboard = Loadable(lazy(() => import('pages/dashboard')));
const UsersPage = Loadable(lazy(() => import('pages/users')));
const UserDetails = Loadable(lazy(() => import('pages/users/UserDetails')));
const SubscriptionsPage = Loadable(lazy(() => import('pages/subscriptions')));
const TournamentsPage = Loadable(lazy(() => import('pages/tournaments')));
const InfluencersPage = Loadable(lazy(() => import('pages/influencers')));
const LeaderboardPage = Loadable(lazy(() => import('pages/leaderboard')));
const NotificationsPage = Loadable(lazy(() => import('pages/notifications')));
const EventsPage = Loadable(lazy(() => import('pages/events')));
const EventDetails = Loadable(lazy(() => import('pages/events/EventDetails')));
const ReportsPage = Loadable(lazy(() => import('pages/reports')));
const MarathonPage = Loadable(lazy(() => import('pages/marathon')));
const MarathonForm = Loadable(lazy(() => import('pages/marathon/MarathonForm')));
const MarathonDetails = Loadable(lazy(() => import('pages/marathon/MarathonDetails')));
const RewardPage = Loadable(lazy(() => import('pages/reward')))

// Master
const CategoryPage = Loadable(lazy(() => import('pages/master/category')));
const GoalPage = Loadable(lazy(() => import('pages/master/goal')));
const BadgePage = Loadable(lazy(() => import('pages/master/badge')));


// CMS
const CmsPage = Loadable(lazy(() => import('pages/cms')));
const AboutUsPage = Loadable(lazy(() => import('pages/cms/about-us')));
const AboutUsAddEdit = Loadable(lazy(() => import('pages/cms/about-us/AboutUsAddEdit')));
const FaqPage = Loadable(lazy(() => import('pages/cms/faq')));
const SmartTipsPage = Loadable(lazy(() => import('pages/cms/smart-tips')));

const MainRoutes = {
  path: '/',
  element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
  children: [
    { index: true, element: <Navigate to="/dashboard" replace /> },
    { path: 'dashboard', element: <Dashboard /> },
    { path: 'users', element: <UsersPage /> },
    { path: 'users/details', element: <UserDetails /> },
    { path: 'subscriptions', element: <SubscriptionsPage /> },
    { path: 'tournaments', element: <TournamentsPage /> },
    { path: 'influencers', element: <InfluencersPage /> },
    { path: 'leaderboard', element: <LeaderboardPage /> },
    { path: 'notifications', element: <NotificationsPage /> },
    { path: 'events', element: <EventsPage /> },
    { path: 'events/details', element: <EventDetails /> },
    { path: 'marathon', element: <MarathonPage /> },
    { path: 'reward/:id', element: <RewardPage /> },
    { path: 'marathon/add', element: <MarathonForm /> },
    { path: 'marathon/edit', element: <MarathonForm /> },
    { path: 'marathon/details', element: <MarathonDetails /> },
    { path: 'reports', element: <ReportsPage /> },

    // Master routes
    { path: 'master/category', element: <CategoryPage /> },
    { path: 'master/goal', element: <GoalPage /> },
    { path: 'master/badge', element: <BadgePage /> },

    // CMS routes
    { path: 'cms/about-us', element: <AboutUsPage /> },
    { path: 'cms/about-us/create', element: <AboutUsAddEdit /> },
    { path: 'cms/about-us/edit', element: <AboutUsAddEdit /> },
    { path: 'cms/faq', element: <FaqPage /> },
    { path: 'cms/smart-tips', element: <SmartTipsPage /> },
    { path: 'cms/:cmsType', element: <CmsPage /> },
  ],
};

export default MainRoutes;
